function Blankpage() {
  return (
    <></>
  )
}

export default Blankpage